import { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';

import { IntegrationEmailPage } from './pages/IntegrationEmailPage';
import { SHOP_CURRENT_ROUTE } from '../../utils/constants';

const routes: RouteObject[] = [
    {
        path: `${SHOP_CURRENT_ROUTE}/integration-email`,
        element: <Outlet />,
        children: [
            {
                index: true,
                element: <IntegrationEmailPage />,
            },
        ],
    },
];
export default routes;
